<div class="flex flex-col sm:flex-row items-center justify-center sm:justify-start mt-4">
    <div class="flex items-center justify-center w-10 h-10 rounded-full bg-primary-50">
        <mat-icon color="primary">warning</mat-icon>
    </div>
    <h2 class="font-semibold text-xl">Confirmar Acción</h2>
</div>
<mat-dialog-content class="flex-col items-center ml-0 sm:ml-5 pt-0 px-2 sm:px-5">
    <p class="text-center sm:text-left">{{ message }}</p>
    <mat-form-field class="w-full mt-2">
        <textarea matInput required [(ngModel)]="inputValue" [placeholder]="inputPlaceholder"></textarea>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-center sm:justify-end">
  <button mat-stroked-button class="border border-gray-500" (click)="onCancel()">Cancelar</button>
  <button mat-button class="bg-primary text-white"[disabled]="!inputValue" (click)="onConfirm()">Confirmar</button>
</mat-dialog-actions>
